/* eslint-disable space-before-function-paren */
/* eslint-disable indent */
import SignageApi from '@/controllers/SignageApi'
import { deviceManagementUrl } from '@/env'
import * as types from '@/store/mutation-types'

export default {
    async GetAllSignageDevices({ commit }, query) {
        // const url = `${deviceManagementUrl}/api/v1/devices`
        const url = `${deviceManagementUrl}/api/v1/devices?&withLocations=false`
        await SignageApi.getApi(url)
            .then(response => {
                // console.log('all', response.data.payload)
                commit(types.SET_ALL_SIGNAGE_DEVICES, response.data.payload)
            })
    },
    async GetAllSignageDevicesPagedWithLocations({ commit }, query) {
        // const url = `${deviceManagementUrl}/api/v1/devices`
        const url = `${deviceManagementUrl}/api/v1/devices?withLocation=${query.withLocations}`
        await SignageApi.getApi(url)
            .then(response => {
                // console.log(response.data.payload)
                commit(types.SET_ALL_SIGNAGE_DEVICES_PAGED_WITH_L0CATIONS, response.data.payload)
            })
    },

    async UpdateSignageDeviceName({ }, value) {
        const url = `${deviceManagementUrl}/api/v1/devices/${value.uuid}`
        await SignageApi.patchApi(url, value.data)
    },
    async GetSignageDeviceDetails({ }, id) {
        const url = `${deviceManagementUrl}/api/v1/devices/${id}`
        await SignageApi.getApi(url)
        // .then(response => {
        //     console.log(response.data.payload)
        // })
    },

    async AssignLocationToDevice({ }, value) {
        const url = `${deviceManagementUrl}/api/v1/devices/${value.uuid}/locations`
        await SignageApi.patchApi(url, value.data).then(response => {
            console.log(response.data.payload)
        })
    },

    async GetBeaconLogs({ commit }, value) {
        // const url = `${deviceManagementUrl}/api/v1/beacons/logs/devices/{{device_id}}?start_date=2019-12-12&end_date=2019-12-31`
        const url = `${deviceManagementUrl}/api/v1/beacons/logs/devices/${value.id}?start_date=${value.startDate}&end_date=${value.endDate}`
        await SignageApi.getApi(url).then(response => {
            commit(types.SET_BEACON_LOGS, response.data.payload)
        })
    },

    async GetDevicesReportSummary({ commit }) {
        const url = `${deviceManagementUrl}/api/v1/devices/all/summaries`
        await SignageApi.getApi(url)
            .then(response => {
                // console.log(response.data.payload)
                commit(types.SET_DEVICES_SUMMARY, response.data.payload)
            })
    },

    async GetCampaignsForDevice({ commit }, uuid) {
        const url = `${deviceManagementUrl}/api/v1/devices/${uuid}/campaigns`
        await SignageApi.getApi(url).then(response => {
            commit(types.SET_DEVICES_CAMPAIGN, response.data.payload)
        })
    },

    async PublishDeviceCampaign({ commit }, value) {
        const url = `${deviceManagementUrl}/api/v1/devices/${value.deviceId}/campaigns/${value.campaignId}`
        const { data: { payload } } = await SignageApi.patchApi(url)
        return payload
    },

    async TriggerDevice({ commit }, value) {
        const url = `${deviceManagementUrl}/api/v1/devices/triggers`
        await SignageApi.postApi(url, value)
    },

    async GetAllRequestsByDevice({ commit }, value) {
        const url = `${deviceManagementUrl}/api/v1/devices/${value.uuid}/picture_requests`
        const { data: { payload } } = await SignageApi.getApi(url)
        commit(types.SET_DEVICES_REQUESTS, payload)
        return payload
    },

    async GetDevicesStatusLogs({ commit }, params) {
        const url = `${deviceManagementUrl}/api/v1/devices/status_logs`
        const { data: { payload } } = await SignageApi.getApi(url, params)
        commit(types.SET_DEVICES_STATUS_LOGS, payload)
        return payload
    }
}
